<template>
    <div id="homeBox">
        <!--搜索时间头部-->
        <div class="flex mrt5">
            <el-input  style="width: 15%" v-model="defaultValue" clearable size="mini" disabled></el-input>
            <el-select class="mrl2" v-model="gsname" placeholder="请选择公司" @change="changeCompany" size="mini" filterable required  >
                <el-option
                        v-for="item in companyName"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-input class="mrl2" style="width: 15%" v-model="vcName" placeholder="请输入品名" clearable size="mini"></el-input>
            <el-button class="mrl15" icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            <el-button class="mrl15" type="primary"  :class="baseerp+'btn'" size="mini" @click="updInSell()" >{{$t('button_save')}}</el-button>
        </div>
        <!--列表-->
        <el-table
                size="mini"
                ref="deliverlight"
                class="mrt5"
                :data="tableData"
                style="width: 100%"
                :height="tableHeight"
                :highlight-current-row="highlightCurrentRow"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
        >
            <!--@selection-change="handleSelectionChange"-->
            <!--<el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>-->
            <el-table-column
                    prop="i_id"
                    label="ID"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    label="公司名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="数量"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    label="无税单价(暂估)"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price_js"
                    label="无税单价(结算)"
                    width="100">
                <template slot-scope="scope">
                    <el-input-number :controls="false" :min="0" :precision="2" class="input" size="mini" v-model="scope.row.f_price_js" :disabled="scope.row.i_state==1">
                    </el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    label="客户名称"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="录入人名字"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    label="录入时间"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    fixed="right"
                    label="操作"
                    width="150">
                <template slot-scope="scope">
                    <el-button @click="WatchClick(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" slot="reference" @click="submitData(scope.row)" v-show="scope.row.i_id!=0" :disabled="scope.row.i_state==3||scope.row.i_state==1">审批</el-button>
                    <el-button @click="costClick(scope.row)" type="text" size="small" v-show="scope.row.file_name">费用</el-button>
                </template>
            </el-table-column>-->
        </el-table>
        <!--分页-->
        <div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="CurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import * as API from "../api"
    import {mapActions} from "vuex";
    //import * as jUtil from '../../utils/spreadJs.js';
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";


    export default {
        name: "TransactionInside",
        /*components: {SheetData,CostList},*/
        data() {
            return {
                vcName:"",
                multipleSelection:"",
                companyName:[],
                gsid:0,
                gsname:"",

                loading:false,
                mid:0,
                title:"",
                //审批
                checkdialogVisible:false,
                //费用
                costdialogVisible:false,
                //
                i_state:"",
                vcState:[
                    {i_state:0,vc_state:"未提交"},
                    {i_state:3,vc_state:"审核中"},
                    {i_state:1,vc_state:"审核通过"},
                    {i_state:-1,vc_state:"审核不通过"},
                ],
                i_type:"",
                vcType:[
                    {i_type:0,vc_type:"自产"},
                    {i_type:1,vc_type:"代加工"},
                ],
                visible: false,
                //mid:0,
                file_name:"",
                dataTime:"",
                defaultValue:"",
                sheet:{},
                dialogVisible:false,
                pageSize:17,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:true,
                tableData:[
                    {i_id:1}
                ],
                baseerp: "",
                file_url: "",
                baseApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
                idData:"",
                idFile:"",
                tableHeight:0,
            }
        },

        computed:{},

        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log('token',this.token,'i_uid',this.i_uid,this.baseApp,this.baseVersion,this.file_url,"123456456")
            //this.getDateMonth();
            this.getCompanyList();
            ////调列表接口
            //this.getInSellList();

            this.$nextTick(function () {
                this.onResize();

            });


        },

        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 220;
            },
            ...mapActions(["getCurrentMenuId"]),

            //多选
            /*handleSelectionChange:function(val) {
                this.multipleSelection = val;
                console.log(val)
            },*/

            //更新内部交易状态
            async updInSell(){
               // console.log(this.tableData,"tableData");
                let details = this.tableData.filter(item=>item.f_price_js!=item.f_price_js_old);
                if (details.length==0){
                    this.$message.error("你没有改动任何价格！");
                    return ;
                }
                let param={
                    i_mid: this.mid,
                    details:details,
                };
                let res=await API.updInSell(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.getInSellList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //公司接口
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid: this.mid,
                    i_type:"1,2,0",
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName=res.data;
                        //this.formData.gsname=this.companyName[0].vc_name;
                        this.gsname=this.companyName[0].vc_name;
                        this.gsid=this.companyName[0].i_id;
                        this.getJsTime();
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            changeCompany(val){
               // console.log("--gsis",val);
                /*if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }*/
                this.gsid=val;
                this.getJsTime();
                /*if (val??''!==''){
                    let obj = this.companyName.find(item => item.i_id == val);
                    this.gsname = obj.vc_name;
                }else {
                    this.gsname='';
                }*/
            },

            //获取未结转时间
            async getJsTime(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.gsid,
                };
                let res=await API.getJsTime(param);
                if(res.code==1){
                    this.defaultValue=res.data.dt_jstime;
                   // console.log(this.defaultValue,"this.defaultValue111")
                    this.getInSellList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //获取内部交易列表
            async getInSellList(){
                let param = {
                    i_mid:this.mid,
                    i_gsid:this.gsid,
                    dt_jstime:this.defaultValue,
                    vc_name:this.vcName,
                    page_size:this.currentPage,
                    page_count:17,
                };
                let res = await API.getInSellList(param);
                if (res.code == 1) {
                    this.tableData=res.data;

                    this.tableTotal=res.count;
                    //console.log(res.data,"resssssss")
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            ////

            /*submitData(row){
                this.checkdialogVisible=true;
                this.title="审批";
                //console.log(row,"shenipi")
                this.idData=row.i_id;
                this.idFile=row.fileId;
                this.i_type=row.i_type;
                //console.log( this.idData,this.idFile,"shenpi")

            },*/

            //提交审批接口
            /*async flowSub() {
                //console.log(this.currentPage,"页码");
                this.visible=true;
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                    appid: this.idData,
                    fileid: this.idFile,
                    //flowid: 32,
                    flowid: this.i_type==0?32:(this.i_type==1?33:"")
                };
                // console.log(this.i_type,param,"123");
                let res = await API.flowSub(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.checkdialogVisible=false;
                    this.$message.success(res.message);
                    this.getStatisticsList();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },*/



            //查询
            Search(){
                //console.log(this.i_state,this.i_type,this.defaultValue,"search");
                this.getInSellList();
                ////调列表接口
            },

            //获取当月日期
            getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                //const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.defaultValue=`${date.getFullYear()}-${month}`;
                this.dataTime=`${date.getFullYear()}${month}`;
               // console.log(this.defaultValue,"defaultValue")
            },

            //关闭dialog
            /*cancelDialog(){
                if (this.title=="统计报表"){
                    this.dialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.title=="费用"){
                    this.costdialogVisible=false;
                    this.highlightCurrentRow=true;
                }
            },*/


            //点击费用
            /*costClick(row){
                //console.log(row,"row");
                this.highlightCurrentRow=true;
                this.title="费用";
                this.cost={
                    //taskId:this.taskId,
                    //taskDa:this.taskDa,
                    //page_size:this.currentPage,
                    //timeData:this.defaultValue,
                    //dataTime:this.dataTime,
                    title:"费用",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                console.log(this.cost ,"费用row");
                this.costdialogVisible=true;
            },*/

            //点击查看
            /*WatchClick(row){
                //console.log(row,"row");
                this.highlightCurrentRow=true;
                this.title="统计报表";
                this.sheet={
                    //taskId:this.taskId,
                    //taskDa:this.taskDa,
                    page_size:this.currentPage,
                    timeData:this.defaultValue,
                    dataTime:this.dataTime,
                    title:"统计报表",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                console.log(this.sheet,"查看sheet");
                this.dialogVisible=true;
            },*/

            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                this.getInSellList();
                ////调列表接口
            },


        },

        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .input{
        width:70px;
    }

    .componentContainer {
        //position: absolute;
        padding: 10px;
        left: 242px;
        top: 0;
        bottom: 20px;
        right: 0;
    }
    .spreadContainer {
        padding: 10px;
        box-shadow: 0 0 20px grey;
    }
    .spreadContainer{
        //position: absolute;
        left: 0px;
        right: 30px;
        top: 100px;
        bottom: 10px;
    }

    .spread-host {
        width: 500px;
        height: 600px;
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .wd{
        width: 150px;
    }

    /deep/{
        .el-dialog__body{
            word-break:unset;
            height: 620px;
            padding: 5px 20px;
        }

        .dia .el-dialog__body{
            word-break:unset;
            height: 100px;
            padding: 5px 20px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 8px;
        }



    }

</style>